import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

type StatusFilter = 'all' | 'active' | 'archived';

type Params = {
  status: StatusFilter;
  search: string;
  page: number;
  perPage: number;
};

async function fetchTopicListPaged(spaceId: string, params: Params) {
  const from = (params.page - 1) * params.perPage;
  const to = from + params.perPage - 1;

  let query = apiClient
    .from('topics')
    .select('*', { count: 'exact' })
    .eq('space_id', spaceId)
    .order('name', { ascending: true })
    .range(from, to);

  if (params.status === 'active') {
    query = query.is('archived', false);
  } else if (params.status === 'archived') {
    query = query.is('archived', true);
  }

  const search = params.search.trim();
  if (search) {
    query = query.ilike('name', `%${search}%`);
  }

  const { data, error, count } = await query;

  if (error) {
    throw error;
  }

  return { rows: data ?? [], total: count ?? 0 };
}

export function useGetTopicListPaged(params: Params) {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: [...keys.topicListPaged(params.status, params.search, params.page, params.perPage), { spaceId: currentSpace?.id }],
    queryFn: () => fetchTopicListPaged(currentSpace!.id, params),
    enabled: !!currentSpace?.id,
    placeholderData: keepPreviousData,
  });
}
